import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./Navbar";
import Home from "./Home";
import './App.css';
import Sanwe from './Sanwe';
import Mouta from "./Mouta";
import Trbwe from "./Trbwe";
import Jame3e from "./Jame3e";
import Mahni from "./Mahni";
import Lang from "./Lang";
import Dawrat from "./Dawrat";
import Nadawe from "./Nadawe";
import WhatsAppButton from "./WhatsAppButton";
import Footer from "./Footer";
import Projet from "./Projet";


  function App() {
  return (
    <Router>
      <div className="app-container">
        <header>
          <Navbar />
        </header>

        <main className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Sanwe" element={<Sanwe />} />
            <Route path="/Mouta" element={<Mouta />} />
            <Route path="/Trbwe" element={<Trbwe />} />
            <Route path="/Jame3e" element={<Jame3e />} />
            <Route path="/Mahni" element={<Mahni />} />
            <Route path="/Lang" element={<Lang />} />
            <Route path="/Dawrat" element={<Dawrat />} />
            <Route path="/Projet" element={<Projet />} />
            <Route path="/Nadawe" element={<Nadawe />} />
  
          </Routes>
          <WhatsAppButton />
        </main>
            <br/><br/><br/>
        <Footer />
      </div>
    </Router>
  );
}

export default App;